<template>
  <a-modal
    ref="model"
    centered
    :title="title"
    v-model="visible"
    width="70%"
    okText="确认"
    :footer="null"
    @cancel="onCancel"
    :maskClosable="false"
    :destroyOnClose="true"
    :bodyStyle="{ paddingTop: 0 }"
  >
    <a-spin :spinning="spinning">
      <div class="content">
        <a-tabs>
          <a-tab-pane tab="基本信息" key="1">
            <dataForm
              :colnum="2"
              :data="baseDefalutData"
              :content="baseContent"
              :labelCol="8"
              :wrapperCol="16"
              ref="baseForm"
              :showButton="false"
            >
            </dataForm>
          </a-tab-pane>
          <a-tab-pane tab="充值方案" key="2" :forceRender="true">
            <dataForm
              :colnum="2"
              :data="rechargeDefalutData"
              :content="rechargeContent"
              :labelCol="8"
              :wrapperCol="16"
              ref="rechargeForm"
              :showButton="false"
            >
            </dataForm>
          </a-tab-pane>
          <a-tab-pane tab="积分规则" key="3" :forceRender="true">
            <dataForm
              :colnum="2"
              :content="ruleContent"
              :data="ruleDefalutData"
              :labelCol="8"
              :wrapperCol="16"
              ref="ruleForm"
              :showButton="false"
            >
              <template slot="slot1">
                <a-input-group compact>
                  <a-select
                    style="width: 30%"
                    v-model="PointPlanList.RuleState"
                    :disabled="this.type == 2"
                  >
                    <a-select-option
                      v-for="(item, index) in ruleStateData"
                      :value="item.Id"
                      :key="index"
                      >{{ item.Text }}</a-select-option
                    >
                  </a-select>
                  <span
                    class="ant-input-group-addon"
                    style="width: 20%;height:32px;line-height:32px;"
                    >每消费1元积</span
                  >
                  <a-input-number
                    :min="0"
                    :precision="2"
                    style="width: 40%"
                    v-model="PointPlanList.CanPoint"
                    :disabled="this.type == 2"
                  />
                  <span
                    class="ant-input-group-addon"
                    style="width: 10%;height:32px;line-height:32px;border-left:1px solid #d9d9d9"
                    >分</span
                  >
                </a-input-group>
              </template>
            </dataForm>
          </a-tab-pane>
          <a-tab-pane tab="优惠方案" key="4" :forceRender="true">
            <dataGrid
              ref="ruleGrid"
              v-model="DiscountPlanList"
              :columns="ruleColumn"
              :autoLoad="false"
              rowKey="CompanyId"
            >
            </dataGrid>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="form-action">
        <a-button
          type="primary"
          @click="onSubmit"
          :disabled="type == 2"
          :loading="confirmLoading"
          >确认</a-button
        >
        <a-button @click="onCancel">取消</a-button>
      </div>
      <addRoomPrice ref="addRoomPrice" title="查看房价" />
    </a-spin>
  </a-modal>
</template>
<script>
import { cache } from "@/utils/common.js";
import dataGrid from "@/components/dataGrid/DataGrid";
import dataForm from "@/components/dataForm/DataForm";
import addRoomPrice from "@/views/salesmanage/AddRoomPrice/AddRoomPrice";
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: "TypeEdit",
  components: {
    dataForm,
    dataGrid,
    addRoomPrice
  },
  data() {
    return {
      id: 0,
      type: 0,
      title: "新增",
      confirmLoading: false,
      spinning: false,
      visible: false,
      ruleStateData: [], //四舍五入规则下拉数据
      DiscountPlanList: [
        {
          CompanyId: "",
          CompanyName: "",
          Id: "",
          MemberCardTypeId: "",
          PriceCodeList: [{ Id: "1", Text: "123" }]
        }
      ],
      ruleColumn: [],
      rechargeContent: [],
      baseContent: [],
      ruleContent: [],
      PointPlanList: {},
      baseDefalutData: {},
      rechargeDefalutData: {},
      ruleDefalutData: {},
      user: cache.get("user")
    };
  },
  created() {
    this.user = cache.get("user");
    var url = {
      MemberCardTypeById: "MemberCardTypeById",
      MemberAddCardType: "MemberAddCardType",
      MemberUpdateCardType: "MemberUpdateCardType"
    };
    if (this.user.IsGroupSystem) {
      for (let i in url) {
        url[i] = "Group" + url[i];
      }
    }
    this.url = url;
  },
  mounted() {},
  methods: {
    init() {
      let _this = this;
      let user = this.user;
      //优惠方案数据
      this.DiscountPlanList = [];
      // this.$nextTick(() => {
      //四舍五入
      this.$post("GetGroupSelectItems", {
        Types: "RuleFlag"
      }).then(res => {
        this.ruleStateData = res.Data.RuleFlag;
      });
      //基本信息
      this.baseContent = [
        {
          type: "hidden",
          name: "Id"
        },
        {
          label: "代码",
          placeholder: "请输入代码",
          name: "Code",
          props: {
            disabled: this.type == 2
          },
          option: {
            rules: [{ required: true, message: "请输入代码" }]
          }
        },
        {
          label: "名称",
          placeholder: "请输入名称",
          name: "Name",
          props: {
            disabled: this.type == 2
          },
          option: {
            rules: [{ required: true, message: "请输入名称" }]
          }
        },
        {
          label: "时间",
          name: "timeRange",
          type: "date-range",
          props: {
            disabled: this.type == 2,
            placeholder: ["开始日期", "结束日期"]
          },
          option: {
            rules: [{ required: true, message: "请选择时间" }]
          }
        },
        // {
        //   label: "销售价格",
        //   type: "number",
        //   name: "SalePrice",
        //   min: 0,
        //   props: {
        //     disabled: this.type == 2,
        //     precision: 2,
        //     message: "请输入销售价格"
        //   },
        //   option: {
        //     rules: [{ required: true, message: "请输入销售价格" }]
        //   }
        // },
        // {
        //   label: "续卡金额",
        //   type: "number",
        //   name: "ContinueCard",
        //   min: 0,
        //   props: {
        //     disabled: this.type == 2,
        //     precision: 2,
        //     message: "请输入续卡金额"
        //   },
        //   option: {
        //     rules: [{ required: true, message: "请输入续卡金额" }]
        //   }
        // },
        {
          label: "适用公司",
          type: "multipleSelect",
          name: "ApplyCompanyId",
          api: "GetGroupSelectItems",
          param: {
            Types: "company",
            CompanyId: user.CompanyId
          },
          onChange: this.discountPlanListChange,
          dataField: "Data.company",
          props: {
            disabled: !user.IsGroupSystem || this.type == 2
          },
          option: {
            rules: [{ required: true, message: "请选择适用公司" }]
          }
        },
        {
          label: "状态",
          type: "select",
          name: "Status",
          api: "GetGroupSelectItems",
          param: {
            Types: "ValidStatus",
            CompanyId: user.CompanyId
          },
          props: {
            disabled: this.type == 2
          },
          option: {
            rules: [{ required: true, message: "请选择状态" }]
          },
          dataField: "Data.ValidStatus"
        },
        {
          label: "排序",
          type: "number",
          name: "Sort",
          props: {
            disabled: this.type == 2,
            message: "请输入排序"
          },
          option: {
            rules: [{ required: true, message: "请输入排序" }]
          }
        },

        // {
        //   label: "半日租时间",
        //   name: "HalfDayRent",
        //   type: "time",
        //   props: {
        //     disabled: this.type == 2,
        //     placeholder: "请输入时间"
        //   }
        // },
        // {
        //   label: "全日租时间",
        //   name: "FullDayRent",
        //   type: "time",
        //   props: {
        //     disabled: this.type == 2,
        //     placeholder: "请输入时间"
        //   }
        // },
        {
          label: "退房时间",
          name: "CheckoutTime",
          type: "time",
          props: {
            disabled: this.type == 2,
            placeholder: "请输入时间"
          }
        },
        {
          label: "初始密码",
          placeholder: "请输入初始密码",
          name: "InitialPwd",
          props: {
            disabled: this.type == 2
          }
        }
        // {
        //   label: "余额小于提醒",
        //   placeholder: "请输入余额小于提醒",
        //   type: "number",
        //   name: "RemindBalance",
        //   min: 0,
        //   props: {
        //     disabled: this.type == 2,
        //     precision: 2
        //   }
        // },
        // {
        //   label: "发卡赠送积分",
        //   type: "number",
        //   name: "PresentPoint",
        //   min: 0,
        //   props: {
        //     disabled: this.type == 2,
        //     precision: 2
        //   }
        // }
      ];
      //充值方案
      this.rechargeContent = [
        {
          type: "hidden",
          name: "Id"
        },
        {
          label: "代码",
          placeholder: "请输入代码",
          name: "Code",
          props: {
            disabled: this.type == 2
          }
        },
        {
          label: "名称",
          placeholder: "请输入名称",
          name: "Name",
          props: {
            disabled: this.type == 2
          }
        },
        {
          label: "充值分类",
          type: "select",
          name: "Category",
          notPlaceSelect: true,
          api: "GetGroupSelectItems",
          param: {
            Types: "RechargeCategory",
            CompanyId: user.CompanyId
          },
          props: {
            disabled: this.type == 2
          },
          dataField: "Data.RechargeCategory"
        },
        {
          label: "状态",
          type: "select",
          name: "Status",
          api: "GetGroupSelectItems",
          notPlaceSelect: true,
          param: {
            Types: "ValidStatus",
            CompanyId: user.CompanyId
          },
          props: {
            disabled: this.type == 2
          },
          dataField: "Data.ValidStatus"
        },

        {
          label: "金额赠送方式",
          type: "select",
          name: "AmountPresentId",
          api: "GetGroupSelectItems",
          notPlaceSelect: true,
          param: {
            Types: "AmountPresentWay",
            CompanyId: user.CompanyId
          },
          props: {
            disabled: this.type == 2
          },
          dataField: "Data.AmountPresentWay"
        },
        {
          label: "积分赠送方式",
          type: "select",
          name: "PointPresentId",
          api: "GetGroupSelectItems",
          notPlaceSelect: true,
          param: {
            Types: "PointPresentWay",
            CompanyId: user.CompanyId
          },
          props: {
            disabled: this.type == 2
          },
          load: (/*list*/) => {},
          onChange: (/*e*/) => {},
          dataField: "Data.PointPresentWay"
        },
        {
          label: "赠送金额/比例",
          placeholder: "请输入赠送金额/比例",
          type: "number",
          name: "PresentAmount",
          min: 0,
          props: {
            disabled: this.type == 2,
            precision: 2,
            formatter: value => {
              if (!_this.$refs.rechargeForm) return `${value}`;
              let data = _this.$refs.rechargeForm.getData();
              return data.AmountPresentId != "1" ? `${value}` : `${value}%`;
            }
          }
        },
        {
          label: "赠送积分/比例",
          placeholder: "请输入赠送积分/比例",
          type: "number",
          name: "PresentPoint",
          props: {
            disabled: this.type == 2,
            precision: 2,
            formatter: value => {
              if (!_this.$refs.rechargeForm) return `${value}`;
              let data = _this.$refs.rechargeForm.getData();
              return data.PointPresentId != "1" ? `${value}` : `${value}%`;
            }
          },
          min: 0
        }
      ];
      //积分规则
      this.ruleContent = [
        {
          type: "hidden",
          name: "Id"
        },
        {
          label: "四舍五入规则",
          slot: "slot1",
          colnum: 2,
          labelCol: 4,
          wrapperCol: 20
        },
        {
          label: "类别",
          type: "select",
          name: "CategorySign",
          api: "GetGroupSelectItems",
          notPlaceSelect: true,
          param: {
            Types: "CategoryFlag",
            CompanyId: user.CompanyId
          },
          props: {
            disabled: this.type == 2
          },
          dataField: "Data.CategoryFlag"
        }
      ];

      //优惠方案列表
      this.ruleColumn = [
        {
          title: "序号",
          width: "100px",
          align: "center",
          type: "indexcolumn"
        },
        { title: "公司名称", dataIndex: "CompanyName" },
        {
          title: "房价体系",
          width: "200px",
          customRender: (text, record, index) => {
            return (
              <a-select
                v-model={record.PriceCodeId}
                style="width: 100%"
                key={index}
                disabled={this.type == 2}
              >
                {record.PriceCodeList.map(p => {
                  return (
                    <a-select-option value={p.Id}>{p.Text}</a-select-option>
                  );
                })}
              </a-select>
            );
          }
        },
        {
          title: "操作",
          width: "100px",
          customRender: (text, record) => {
            return (
              <a-button
                {...{
                  props: {
                    size: "small",
                    type: "primary",
                    disabled: record.PriceCodeId == ""
                  },
                  on: {
                    click: this.action.bind(null, record)
                  }
                }}
              >
                查看
              </a-button>
            );
          }
        }
      ];
      // });
    },
    //数据初始化
    dataInit() {
      let user = this.user;
      this.PointPlanList = {
        Id: 0,
        RuleState: "1",
        CanPoint: 0
      };
      this.baseDefalutData = {
        Id: 0,
        Status: "1",
        SalePrice: 0,
        ContinueCard: 0,
        Sort: 0,
        RemindBalance: 0,
        PresentPoint: 0
      };
      if (!user.IsGroupSystem) {
        this.baseDefalutData.ApplyCompanyId = [user.CompanyId];
        this.discountPlanListChange(
          [user.CompanyId],
          [
            {
              Id: user.CompanyId,
              Text: user.CompanyName
            }
          ]
        );
      }
      this.rechargeDefalutData = {
        Id: 0,
        Status: "1",
        Category: "0",
        AmountPresentId: "0",
        PointPresentId: "0",
        PresentAmount: 0,
        PresentPoint: 0
      };
      this.ruleDefalutData = {
        CategorySign: "0"
      };
    },
    show(type, id = 0) {
      this.spinning = true;
      this.type = type;
      this.id = id;
      this.title = type == 0 ? "新增" : type == 1 ? "编辑" : "查看";
      this.init();
      this.visible = true;
      if (type > 0) {
        this.$nextTick(() => {
          this.edit(id);
        });
      } else {
        this.dataInit();
        this.$nextTick(() => {
          this.spinning = false;
        });
      }
    },
    edit(id) {
      // let user = this.user;
      this.$post(this.url.MemberCardTypeById, {
        Id: id
      }).then(res => {
        this.$nextTick(() => {
          let data = res.Data;
          let MemberCardType = data.MemberCardType;
          // if (!user.IsGroupSystem) {
          //   MemberCardType.ApplyCompanyId = MemberCardType.ApplyCompanyId;
          // }
          MemberCardType.timeRange = [
            moment(MemberCardType.StartTime),
            moment(MemberCardType.EndTime)
          ];
          //基本
          this.baseDefalutData = MemberCardType;
          this.$refs.baseForm.updateData();
          //充值
          const emptyValue = {
            Id: 0,
            Status: "",
            Category: "",
            AmountPresentId: "",
            PointPresentId: "",
            PresentAmount: "",
            PresentPoint: ""
          };
          this.rechargeDefalutData =
            data.RechargePlanList.length > 0
              ? data.RechargePlanList[0]
              : emptyValue;
          this.$refs.rechargeForm.updateData();
          //规则
          if (data.PointPlanList.length > 0) {
            this.ruleDefalutData = data.PointPlanList[0];
            this.$refs.ruleForm.updateData();
            this.PointPlanList = {
              RuleState: data.PointPlanList[0].RuleState,
              CanPoint: data.PointPlanList[0].CanPoint
            };
          } else {
            this.ruleDefalutData = {};
            // this.PointPlanList = {};
          }
          //优惠方案
          this.DiscountPlanList = data.DiscountPlanList;
          this.spinning = false;
        });
      });
    },
    action(row) {
      this.$refs.addRoomPrice.Show("exa", row.PriceCodeId, true);
    },
    discountPlanListChange(value, row) {
      let params = { Types: "pricecode" };
      let index = 0;
      if (value.length <= this.DiscountPlanList.length) {
        index = this.DiscountPlanList.findIndex(o => {
          return row.findIndex(p => o.CompanyId == p.Id) < 0;
        });
        this.DiscountPlanList.splice(index, 1);
      } else {
        index = row.findIndex(p => {
          return this.DiscountPlanList.findIndex(o => o.CompanyId == p.Id) < 0;
        });

        params.CompanyId = row[index].Id;
        this.$post("GetGroupSelectItems", params).then(res => {
          let arr = {
            Id: 0,
            CompanyId: row[index].Id,
            CompanyName: row[index].Text,
            PriceCodeId: "",
            PriceCodeList: res.Data.pricecode
          };
          if (typeof value == "object") {
            this.DiscountPlanList.push(arr);
          } else {
            this.DiscountPlanList = [arr];
          }
        });
      }
    },
    onSubmit() {
      this.$refs.baseForm
        .getData(true)
        .then(res => {
          let MemberCardType = res;
          let RechargePlanList = this.$refs.rechargeForm.getData();
          let PointPlanList = this.$refs.ruleForm.getData();
          let DiscountPlanList = this.DiscountPlanList;
          MemberCardType.Id = this.id;
          MemberCardType.StartTime = moment(res.timeRange[0]).format(
            "YYYY-MM-DD"
          );
          MemberCardType.EndTime = moment(res.timeRange[1]).format(
            "YYYY-MM-DD"
          );
          if (typeof MemberCardType.ApplyCompanyId != "object") {
            MemberCardType.ApplyCompanyId = [MemberCardType.ApplyCompanyId];
          }
          RechargePlanList.MemberCardTypeId = this.id;
          DiscountPlanList.MemberCardTypeId = this.id;
          PointPlanList.MemberCardTypeId = this.id;
          PointPlanList = Object.assign(PointPlanList, this.PointPlanList);
          if (this.hasEmpty(RechargePlanList)) {
            if (!this.hasAllValue(RechargePlanList)) {
              this.$message.error("充值方案全为空，或者全不为空才能提交");
              return false;
            }
            RechargePlanList = [];
          } else {
            RechargePlanList = [RechargePlanList];
          }

          if (this.hasEmpty(PointPlanList)) {
            PointPlanList = [];
          } else {
            PointPlanList = [PointPlanList];
          }

          MemberCardType.RemindBalance = 0;
          MemberCardType.PresentPoint = 0;
          MemberCardType.SalePrice = 0;
          MemberCardType.ContinueCard = 0;
          MemberCardType.HalfDayRent = "";
          MemberCardType.FullDayRent = "";

          let params = {
            MemberCardType: MemberCardType,
            RechargePlanList: RechargePlanList,
            PointPlanList: PointPlanList,
            DiscountPlanList: DiscountPlanList
          };
          this.confirmLoading = true;
          this.$post(
            this.type == 0
              ? this.url.MemberAddCardType
              : this.url.MemberUpdateCardType,
            params
          )
            .then(res => {
              if (res.Data) {
                this.$message.success(this.id == 0 ? "添加成功" : "修改成功");
                this.visible = false;
                this.$emit("submit");
              } else {
                this.$message.error("提交出错,请重试");
              }
              this.confirmLoading = false;
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        })
        .catch(() => {
          this.$message.error("请完成填写表单");
        });
    },
    hasEmpty(data) {
      for (let i in data) {
        if (data[i] === "" || data[i] === undefined) {
          return true;
        }
      }
      return false;
    },
    hasAllValue(data) {
      let hasValue = false;
      for (let i in data) {
        if (data[i] && i != "MemberCardTypeId" && i != "Id") {
          hasValue = true;
          break;
        }
      }
      let hasEmpty = false;
      for (let i in data) {
        if (data[i] === "" || data[i] === undefined) {
          hasEmpty = true;
          break;
        }
      }
      return (hasValue && !hasEmpty) || !hasValue;
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.form-action {
  text-align: center;
  .ant-btn {
    margin-right: 10px;
  }
}

.content {
  min-height: 480px;
}

/deep/.ant-modal-body {
  padding: 0;
}
</style>
